import { useDispatch } from "react-redux";
// components
import {
    CommonPopupCrud,
    customUseEffect,
    InfoIcon,
    InputAdornment,
    MyTextInput,
    Notifier,
    useSelector,
    useState
} from "@common";
import { INTEGRATION_CODE_SAP_SUCCESS_FACTOR } from "@constants";
import { getOAuthPublicCertificateKey } from "@features";
// =====================================================================================================

// =====================================================================================================

const Connect = ({ selectCategory, ...props }) => {
    const integrationSelectedData = useSelector((state) => state.integration?.selectedData);
    // Add integration Code and the Info You want to Display
    const INTEGRATION_CONTENT = {
        [INTEGRATION_CODE_SAP_SUCCESS_FACTOR]: {
            info: (
                <>
                    Copy this certificate and paste it into the{" "}
                    <b>X.509 Certificate</b> field when creating the OAuth
                    integration in SuccessFactors.
                </>
            ),
        },
        DEFAULT: {
            info: <>Copy this certificate and paste it into the{" "}
                <b>X.509 Certificate</b> field when creating the OAuth
                integration</>,
        },
    };

    const data =
        INTEGRATION_CONTENT[integrationSelectedData?.integrationMasterData?.code] || INTEGRATION_CONTENT.DEFAULT;
    const [copyMessage, setCopyMessage] = useState("");
    const [apiKey, setApiKey] = useState("");
    const dispatch = useDispatch();
    customUseEffect(() => {
        dispatch(getOAuthPublicCertificateKey()).then((res) => {
            if (res?.payload?.ok) {
                setApiKey(res?.payload?.data?.public_certificate || "");
            }
        });
    }, []);
    const handleCopyDescription = (description) => {
        try {
            navigator.clipboard.writeText(description);
            setCopyMessage("Certificate Copied");
            setTimeout(() => {
                setCopyMessage("");
            }, 2000);
        } catch (err) {
            console.error("Unable to copy description to clipboard", err);
        }
    };
    return (
        <CommonPopupCrud
            heading="Public Certificate Key"
            close={props.close}
            mediumScreen={true}
        >
            <div
                style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    background: "rgb(208, 238, 255)",
                    borderLeft: "0.5rem solid #38a2ff",
                    borderRadius: "5px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                }}
            >
                <div style={{ display: "flex", alignItems: "flex-start", }}>
                    <InfoIcon style={{ fontSize: "2rem", color: "#38a2ff" }} />
                </div>

                <div style={{ display: "flex", alignItems: "flex-start", }}>
                    <p>{data.info}</p>
                </div>

            </div>
            <MyTextInput
                label="Public Certificate Key"
                type="text"
                name="name"
                required={true}
                fullWidth={true}
                margin="normal"
                id="name"
                value={apiKey}
                InputProps={{
                    endAdornment: (
                        <InputAdornment
                            onClick={() => handleCopyDescription(apiKey)}
                            position="end"
                            style={{ cursor: "pointer" }}
                        >
                            Copy
                        </InputAdornment>
                    ),
                }}
            />
            {copyMessage && <Notifier message={copyMessage} />}
        </CommonPopupCrud>
    );
};

export default Connect;
